/**
 * NAD3 LP Info 1 - Label Popup Functionality
 * Opens/closes popup modal to show product label image
 */

document.addEventListener('DOMContentLoaded', function() {
  
  // Get elements
  const trigger = document.querySelector('.read-the-label');
  const closeButton = document.querySelector('.nad3lp-popup-close');
  const popupWrapper = document.querySelector('.nad3lp-popup-wrapper');
  
  if (!trigger || !closeButton || !popupWrapper) return;
  
  // Open popup when "READ THE LABEL" button is clicked
  trigger.addEventListener('click', function(e) {
    e.preventDefault();
    document.body.classList.add('nad3lp-popup-open');
  });
  
  // Close popup when close button is clicked
  closeButton.addEventListener('click', function() {
    document.body.classList.remove('nad3lp-popup-open');
  });
  
  // Close popup when clicking outside the content area
  popupWrapper.addEventListener('click', function(event) {
    if (event.target === popupWrapper) {
      document.body.classList.remove('nad3lp-popup-open');
    }
  });
  
});
